import { Component } from '@angular/core';
import { IzzyIssueTicketNumberEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Issue Ticket Numbers') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-izzyissueticketnumber-form',
    templateUrl: './izzyissueticketnumber.form.component.html'
})
export class IzzyIssueTicketNumberFormComponent extends BaseFormComponent {
    public record!: IzzyIssueTicketNumberEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'ticketDetails', sectionName: 'Ticket Details', isExpanded: true },
            { sectionKey: 'systemMetadata', sectionName: 'System Metadata', isExpanded: false }
        ]);
    }
}

